import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { generateUrl } from 'utils/helpers';
import { apiLoaderQuery } from 'store/query';

const tagType = 'Appointment Reasons Bitwerx';

export interface AppointmentReason {
  id: number;
  name: string;
  status: number;
  created: string;
  updated: string;
  reason_id: string;
  hospital_id: number;
  reason_text: string;
  deleted?: string | null;
  source_id?: string | null;
}

export interface AppointmentReasonsListRequest {
  hospitalId: number;
}

export interface AppointmentReasonsListResponse {
  data: {
    reasons: AppointmentReason[];
  };
}

export const appointmentReasonsBitwerxApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiLoaderQuery,
  reducerPath: 'appointmentReasonsBitwerxApi',
  endpoints: (build) => ({
    list: build.query<AppointmentReason[], AppointmentReasonsListRequest>({
      providesTags: [tagType],
      transformResponse: (response: AppointmentReasonsListResponse) =>
        response.data.reasons,
      query: ({ hospitalId }) => ({
        method: 'get',
        url: generateUrl(URL.GET_BITWERX_APPOINTMENT_REASONS, {
          id: hospitalId,
        }),
      }),
    }),
  }),
});

export const { useListQuery: useAppointmentReasonsListQuery } =
  appointmentReasonsBitwerxApi;
